import { createFormContext } from '@mantine/form'
import { BuilderFormDataState } from './type'

export const [BuilderFormProvider, useBuilderFormContext, useBuilderForm] = createFormContext<BuilderFormDataState>()
